import { useLocation, useNavigate } from "react-router-dom";
import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';

// material
import { Typography, Button, Box, Stack, Tooltip, TextField, ToggleButtonGroup, ToggleButton, Card, FormControl, IconButton, Autocomplete, Modal, Grid, Checkbox, FormLabel, Chip } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

import { styled } from '@mui/material/styles';
import XLSX from 'sheetjs-style';
import Moment from 'moment';
import * as FileSaver from 'file-saver';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
// components
import AddIcon from "@mui/icons-material/Add";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Icon } from '@iconify/react';
import Iconify from '../../Iconify';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from "@mui/icons-material/Edit";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import AppCache from '../../../services/AppCache';
import URLS from '../../../services/urls.service';
import Page from "../../Page";
import StickyHeader from "../../Common/StickyHeader";
import ServiceCards from '../../Common/ServiceCard'
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.replace(/\s+/g, ' ').trim(); // collapse whitespace and remove line breaks
};

export default function ProjectTeamManagementDetailsPage() {

    const teamColumn = [
        { field: 'ClientId', headerName: 'Client Id', flex: 1 },
        { field: 'ClientName', headerName: 'Client Name', flex: 1.5 },
        { field: 'ClientAlice', headerName: 'Client Alice', flex: 1.5 },
        { field: 'ProjectTeamName', headerName: 'Project Team Name', flex: 1.5 },
        { field: 'Project', headerName: 'Project', flex: 1 },
        { field: 'FromDate', headerName: 'From Date', flex: 0.8 },
        { field: 'ToDate', headerName: 'To Date', flex: 0.8 },
        { field: 'Members', headerName: 'Members', flex: 0.7 },
        { field: 'Status', headerName: 'Status', flex: 1 },
        {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            flex: 0.5,
            renderCell: (cellValues, oaDetailsData) => (
                <div>
                    <IconButton
                        onClick={(event) => {
                            handleTeamClick(event, cellValues, oaDetailsData);
                        }}
                    >
                        <Iconify
                            icon="ic:outline-edit"
                            width="20px"
                            height="20px"
                            color="primary.main"
                        />
                    </IconButton>
                </div>
            ),
        },
    ];

    const teamMemberColumn = [
        { field: 'ClientId', headerName: 'Client Id', flex: 1 },
        { field: 'ClientName', headerName: 'Client Name', flex: 1.5 },
        { field: 'ClientAlice', headerName: 'Client Alice', flex: 1.5 },
        { field: 'ProjectTeamName', headerName: 'Project Team Name', flex: 1.5 },
        { field: 'ExecutiveId', headerName: 'Executive ID', flex: 0.5 },
        { field: 'ExecutiveName', headerName: 'Executive Name', flex: 1 },
        { field: 'EmployeeCode', headerName: 'Employee Code', flex: 1 },
        { field: 'Department', headerName: 'Department', flex: 1 },
        { field: 'FromDate', headerName: 'From Date', flex: 1 },
        { field: 'ToDate', headerName: 'To Date', flex: 1 },
        { field: 'NoOfDays', headerName: 'No Of Days', flex: 0.5 },
        { field: 'IsCoordinator ', headerName: 'Is Coordinator', flex: 1 },
        { field: 'Status', headerName: 'Status', flex: 1 },
        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            flex: 0.5,
            renderCell: (cellValues, oaDetailsData) => (
                <div>
                    <IconButton
                        onClick={(event) => {
                            handleTeamMemberClick(event, cellValues, oaDetailsData);
                        }}
                    >
                        <Iconify
                            icon="ic:outline-edit"
                            width="20px"
                            height="20px"
                            color="primary.main"
                        />
                    </IconButton>
                </div>
            ),
        },

    ];

    const navigate = useNavigate();
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const userId = CurrentLoggedInUser.ExecutiveId;
    const userClientId = CurrentLoggedInUser?.UserClientId;

    const [isLoading, setIsLoading] = useState();
    const [tab, setTab] = useState("teams");
    const [newTeamOpenModal, setNewTeamOpenModal] = useState(false);
    const [teamName, setTeamName] = useState('');
    const [clientTeam, setClientTeam] = useState("");
    const [selectedClientTeam, setSelectedClientTeam] = useState([]);
    const [projectTeam, setProjectTeam] = useState("");
    const [selectedProjectTeam, setSelectedProjectTeam] = useState([]);
    const [executiveTeam, setExecutiveTeam] = useState('');
    const [selectedExecutiveTeam, setSelectedExecutiveTeam] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);

    const [client, setClient] = useState("");
    const [selectedClient, setSelectedClient] = useState([]);
    const [project, setProject] = useState('');
    const [selectedProject, setSelectedProject] = useState([]);
    const [executive, setExecutive] = useState('');
    const [selectedExecutive, setSelectedExecutive] = useState([]);
    const [team, setTeam] = useState("");
    const [selectedTeam, setSelectedTeam] = useState([]);
    const [effectiveFromValue, setEffectiveFromValue] = useState(null);
    const [effectiveToValue, setEffectiveToValue] = useState(null);
    const [showInactive, setShowInactive] = useState(false);
    const [teamData, setTeamData] = useState([]);
    const [teamMemberData, setTeamMemberData] = useState([]);
    const [pageSize, setPageSize] = useState(25);
    const [pageSize1, setPageSize1] = useState(25);
    const [createNew, setCreateNew] = useState(false);

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: executiveTeam.length > 0 ? '90%' : '40%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        maxHeight: '70vh',
        overflow: 'auto',
        borderRadius: '8px',
    };

    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {
                setSelectedClient(Array.isArray(response.data) ? response.data : []);
                setSelectedClientTeam(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        URLS.getServiceEntryProject()

            .then((response) => {
                setSelectedProject(Array.isArray(response.data) ? response.data : []);
                setSelectedProjectTeam(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadExecutives(userClientId)
            .then((response) => {
                setSelectedExecutive(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        const payloadExecutive = { ExecutiveLoginId: 0 };
        URLS.getExecutiveInfo(payloadExecutive)
            .then((response) => {
                setSelectedExecutiveTeam(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log("Error");
            });
    }, []);

    const handleTeamName = (event) => {
        setTeamName(event.target.value);
    }
    const handleNewTeamOpenModal = () => {
        setNewTeamOpenModal(true);
    }
    const handleNewTeamCloseModal = () => {
        setNewTeamOpenModal(false);
    }
    const handleClientTeam = (newValue) => {
        setClientTeam(newValue?.ClientId || "");
    };
    const handleProjectTeam = (newValue) => {
        setProjectTeam(newValue?.ProjectVersionId || "");
    };
    const handleExecutiveTeam = (newValue) => {
        const executive = newValue.map((item) => item.Id);
        setExecutiveTeam(executive);
        setSelectedMembers(newValue);
    };
    const handleClient = (newValue) => {
        setClient(newValue?.ClientId || "");
    };
    const handleProject = (newValue) => {
        setProject(newValue?.ProjectVersionId || "");
    };
    const handleTeam = (newValue) => {
        setTeam(newValue?.SiteId || "");
    };

    const handlExecutive = (newValue) => {
        setExecutive(newValue?.Id || "");
    };
    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue);

    };
    const handleEffTo = (newValue) => {
        setEffectiveToValue(newValue);
    };
    const handleTabChange = (event, newView) => {
        if (newView !== null) {
            setTab(newView);
        }
    };
    const handleInactiveToggle = () => {
        setShowInactive((prev) => !prev);
    };
    const handleReset = () => {
        setClient("");
        setEffectiveFromValue(null);
        setEffectiveToValue(null);
    };

    const handleTeamClick = (event, rowData) => {
        console.log("rowData", rowData, rowData?.ServiceId)
        URLS.editLoadServiceData({ ServiceId: rowData?.ServiceId })
            .then((response) => {
                const apiData = Array.isArray(response.data)
                    ? response.data[0]   //  object
                    : response.data;


                navigate("/dashboard/servicedetailspage", {
                    state: {
                        loadData: apiData, // object
                        openServiceTab: true,
                        fromEdit: true,
                    },
                });
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        console.log("************************", rowData);
    };
    const handleTeamMemberClick = (event, rowData) => {
        console.log("rowData", rowData, rowData?.ServiceId)
        URLS.editLoadServiceData({ ServiceId: rowData?.ServiceId })
            .then((response) => {
                const apiData = Array.isArray(response.data)
                    ? response.data[0]   //  object
                    : response.data;


                navigate("/dashboard/servicedetailspage", {
                    state: {
                        loadData: apiData, // object
                        openServiceTab: true,
                        fromEdit: true,
                    },
                });
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        console.log("************************", rowData);
    };

    const exportToExcel = () => {
        const fileExtension = ".xlsx";
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

        // Columns to exclude
        const excludeColumns = [
            "executiveId",
            "ClientId",
            "SiteId",
            "IssueOwnedById",
            "ReportingToId",
            "SubstatusId",
            "ProjectVersionId",
            "executiveId",
            "ProjectId",
            "LastAllocatedById",
            "IssueCategoryId",
            "ActivityId",
            "ContactPersonId",
            "ExecutiveId",
            "ServiceTypeId",

        ];

        // Check if reports are available
        if (!filteredServiceData || filteredServiceData.length === 0) {
            enqueueSnackbar("No data available to export.", { variant: "error" });
            return;
        }

        // Prepare headers excluding unwanted columns
        const headers = Object.keys(filteredServiceData[0]).filter(
            (key) => !excludeColumns.includes(key)
        );
        // Prepare the row data based on reports data
        const dataToExport = filteredServiceData.map((row) =>
            headers.map((header) => {
                const cellValue = row[header];
                // Apply stripHtml if the value is a string
                return typeof cellValue === "string" ? stripHtml(cellValue) : cellValue;
            })
        );

        const dataWithHeaders = [headers, ...dataToExport]; // Combine headers with data rows
        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders); // Convert to AOA format
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] }; // Create workbook
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" }); // Write workbook to buffer
        const data = new Blob([excelBuffer], { type: fileType }); // Create a blob from the buffer

        const timestamp = Moment().format("DD-MMM-YYYY_HH-mm-ss");
        const fileName = `EditServiceListing_${timestamp}${fileExtension}`; // Add dynamic name

        FileSaver.saveAs(data, fileName); // Save the file
        enqueueSnackbar("Exported Excel successfully.", { variant: "success" });
    };

    const onFilterClick = () => {
        setIsLoading(true);
        const payload = {
            "IssueId": Number(issueId) || 0,
            "UserId": userId || 0,
            "ClientId": client || 0,
            "SiteId": site || 0,
            "ContactPersonId": executive || 0,
            "FromDate": effectiveFromValue ? Moment(effectiveFromValue).format("DD/MMM/YYYY") : "",
            "ToDate": effectiveToValue ? Moment(effectiveToValue).format("DD/MMM/YYYY") : ""
        }
        console.log("filter payload", payload)
        URLS.editLoadServiceFilter(payload)
            .then((response) => {
                if (Array.isArray(response.data)) {
                    setTeamData(response.data);
                    setIsLoading(false);
                }
            })
            .catch(error => {
                setTeamData([]);
                enqueueSnackbar("Data not found", { variant: 'error' });
                setIsLoading(false);

            });
    };
    const handleCreateNew = () => {
        setCreateNew(true);
    }
    useEffect(() => {
        handleReset();
    }, [location.key]);

    const teamRows = [
        {
            id: 1,
            ClientId: "C001",
            ClientName: "ABC Corporation",
            ClientAlice: "Alice Johnson",
            ProjectTeamName: "Alpha Team",
            Project: "CRM Implementation",
            FromDate: "01-Jan-2026",
            ToDate: "30-Jun-2026",
            Members: "John, Priya, Rahul",
            Status: "Active",
            TeamName: "3M"
        },
        {
            id: 2,
            ClientId: "C002",
            ClientName: "XYZ Technologies",
            ClientAlice: "Michael Smith",
            ProjectTeamName: "Beta Squad",
            Project: "Mobile App Development",
            FromDate: "15-Feb-2026",
            ToDate: "15-Sep-2026",
            Members: "Anita, Vikram, Sneha",
            Status: "Active",
            TeamName: "Bira"

        },
        {
            id: 3,
            ClientId: "C003",
            ClientName: "Global Solutions",
            ClientAlice: "Emma Williams",
            ProjectTeamName: "Gamma Group",
            Project: "ERP Upgrade",
            FromDate: "01-Mar-2025",
            ToDate: "31-Dec-2025",
            Members: "Arjun, Meena, Karan",
            Status: "Completed",
            TeamName: "Test"

        },
        {
            id: 4,
            ClientId: "C004",
            ClientName: "TechNova Pvt Ltd",
            ClientAlice: "David Brown",
            ProjectTeamName: "Delta Force",
            Project: "Cloud Migration",
            FromDate: "10-Apr-2026",
            ToDate: "10-Sep-2026",
            Members: "Riya, Mohit, Aakash",
            Status: "Pending",
            TeamName: "CC"

        },
        {
            id: 5,
            ClientId: "C005",
            ClientName: "NextGen Systems",
            ClientAlice: "Sophia Davis",
            ProjectTeamName: "Omega Team",
            Project: "Website Redesign",
            FromDate: "05-Jan-2026",
            ToDate: "05-May-2026",
            Members: "Neha, Rohit, Simran",
            Status: "Active",
            TeamName: "Test2"

        }
    ];

    const teamMemberRows = [
        {
            id: 1,
            ClientId: "C001",
            ClientName: "ABC Corporation",
            ClientAlice: "Alice Johnson",
            ProjectTeamName: "Alpha Team",
            ExecutiveId: "E101",
            ExecutiveName: "Rahul Sharma",
            EmployeeCode: "EMP001",
            Department: "Development",
            FromDate: "01-01-2026",
            ToDate: "31-01-2026",
            NoOfDays: 31,
            IsCoordinator: "Yes",
            Status: "Active",
        },
        {
            id: 2,
            ClientId: "C001",
            ClientName: "ABC Corporation",
            ClientAlice: "Alice Johnson",
            ProjectTeamName: "Alpha Team",
            ExecutiveId: "E102",
            ExecutiveName: "Priya Mehta",
            EmployeeCode: "EMP002",
            Department: "QA",
            FromDate: "01-01-2026",
            ToDate: "31-01-2026",
            NoOfDays: 31,
            IsCoordinator: "No",
            Status: "Active",
        },
        {
            id: 3,
            ClientId: "C002",
            ClientName: "XYZ Technologies",
            ClientAlice: "Michael Smith",
            ProjectTeamName: "Beta Squad",
            ExecutiveId: "E103",
            ExecutiveName: "Amit Verma",
            EmployeeCode: "EMP003",
            Department: "UI/UX",
            FromDate: "15-02-2026",
            ToDate: "15-03-2026",
            NoOfDays: 29,
            IsCoordinator: "Yes",
            Status: "Completed",
        },
        {
            id: 4,
            ClientId: "C003",
            ClientName: "Global Solutions",
            ClientAlice: "Emma Williams",
            ProjectTeamName: "Gamma Group",
            ExecutiveId: "E104",
            ExecutiveName: "Sneha Patil",
            EmployeeCode: "EMP004",
            Department: "Support",
            FromDate: "01-03-2026",
            ToDate: "20-03-2026",
            NoOfDays: 20,
            IsCoordinator: "No",
            Status: "Pending",
        },
        {
            id: 5,
            ClientId: "C004",
            ClientName: "TechNova Pvt Ltd",
            ClientAlice: "David Brown",
            ProjectTeamName: "Delta Force",
            ExecutiveId: "E105",
            ExecutiveName: "Karan Singh",
            EmployeeCode: "EMP005",
            Department: "DevOps",
            FromDate: "10-04-2026",
            ToDate: "25-04-2026",
            NoOfDays: 16,
            IsCoordinator: "No",
            Status: "Active",
        }
    ];

    return (
        <Box sx={{
            display: 'flex', gap: 2, px: 1.5, overflow: 'hidden'
        }}>
            <Box sx={{ flex: 5.2, }}>
                <Card
                    sx={{
                        p: 0,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        border: '1px solid #E5E5E5',
                        boxShadow: 'none',
                        borderRadius: '12px',
                    }}
                >
                    {/* HEADER */}
                    <Box
                        sx={{
                            p: 1,
                            borderBottom: '1px solid #E5E5E5',
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Box>
                            <Typography variant="subtitle1" fontWeight={600}>
                                {createNew ? "Create New Team" : "Project Team List"}
                            </Typography>
                            <Typography sx={{ color: '#94A3B8', fontSize: '12px' }}>
                                {createNew ? "Fill below details to create new team" : "Search or create new team"}

                            </Typography>
                        </Box>
                        {!createNew && (
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<AddIcon />}
                                onClick={handleCreateNew}
                                sx={{
                                    textTransform: "none",
                                    height: '34px',

                                }}
                            >
                                Create New
                            </Button>
                        )}

                    </Box>
                    {createNew ? (
                        <Box
                            sx={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    flex: 1,
                                    overflowY: "auto"
                                }}
                            >
                                <Stack direction="column" spacing={1.5}>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel sx={{
                                            mb: 0.5,
                                            '&::after': {
                                                content: '" *"',
                                                color: 'red',
                                            },
                                        }}>Team Name</FormLabel>
                                        <TextField
                                            placeholder="Enter unique team name"
                                            value={teamName} // replace with state
                                            onChange={handleTeamName} // replace with handler
                                            size="small" fullWidth
                                        />
                                    </FormControl>

                                    <FormControl size="small" fullWidth>
                                        <FormLabel sx={{
                                            mb: 0.5,
                                            '&::after': {
                                                content: '" *"',
                                                color: 'red',
                                            },
                                        }}>Client</FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            limitTags={2}
                                            size="small"
                                            id="client"
                                            value={selectedClient.find((option) => option.ClientId === client) || ""}
                                            onChange={(_, newValue) => handleClient(newValue)}
                                            options={selectedClient}

                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Clients" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.ClientId}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />

                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel sx={{
                                            mb: 0.5,
                                            '&::after': {
                                                content: '" *"',
                                                color: 'red',
                                            },
                                        }}>Project</FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="project Version"
                                            value={selectedProject.find((item) => item.ProjectVersionId === project) || null}
                                            onChange={(_, newValue) => handleProject(newValue)}
                                            options={selectedProject}
                                            getOptionLabel={(option) => option.ProjectVersionName || ""}
                                            isOptionEqualToValue={(option, value) => option.ProjectVersionId === value.ProjectVersionId}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.ProjectVersionId}>
                                                    {option.ProjectVersionName}
                                                </li>
                                            )}
                                            renderInput={(params) => <TextField {...params} placeholder="Select Project" />}

                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth>
                                        <FormLabel sx={{
                                            mb: 0.5,
                                            '&::after': {
                                                content: '" *"',
                                                color: 'red',
                                            },
                                        }}>Add Team Member</FormLabel>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="executive"
                                            value={selectedExecutive.find((option) => option.Id === executive) || ""}
                                            onChange={(_, newValue) => handlExecutive(newValue)}
                                            options={selectedExecutive}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}

                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Executive" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.Id}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />
                                    </FormControl>

                                </Stack>
                            </Box>
                            <Box
                                sx={{
                                    borderTop: "1px solid #E5E5E5",
                                    p: 1.5,
                                    position: "sticky",
                                    bottom: 0,
                                    background: "#fff"
                                }}
                            >
                                <Stack direction="row" spacing={1} justifyContent="flex-end">

                                    <Button
                                        variant="outlined"
                                        color="inherit"
                                    >
                                        Cancel
                                    </Button>
                                    <Button variant="outlined" color="inherit" onClick={handleReset}>
                                        Reset
                                    </Button>

                                    <LoadingButton
                                        size="medium"
                                        variant="contained" color='primary'
                                        loading={isLoading}
                                    >
                                        Create Team
                                    </LoadingButton>

                                </Stack>
                            </Box>
                        </Box>

                    ) : (
                        <Box sx={{ flex: 1, overflow: 'auto' }}>

                            <Box sx={{ p: 1 }}>


                                <Stack direction="row" spacing={1} alignItems="center">
                                    <FormControl size="small" sx={{ flex: 1 }}>
                                        <Autocomplete
                                            fullWidth
                                            limitTags={2}
                                            size="small"
                                            id="client"
                                            value={selectedClient.find((option) => option.ClientId === client) || ""}
                                            onChange={(_, newValue) => handleClient(newValue)}
                                            options={selectedClient}

                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Clients" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.ClientId}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />

                                    </FormControl>
                                    <FormControl size="small" sx={{ flex: 1 }}>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="team"
                                            value={selectedTeam.find((item) => item.Id === team) || ""}
                                            onChange={(_, newValue) => handleTeam(newValue)}
                                            options={selectedTeam}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(o, v) => o.Id === v.Id}
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Teams" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.Id}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />
                                    </FormControl>
                                    <FormControl size="small" fullWidth sx={{ flex: 1 }} >
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="executive"
                                            value={selectedExecutive.find((option) => option.Id === executive) || ""}
                                            onChange={(_, newValue) => handlExecutive(newValue)}
                                            options={selectedExecutive}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.Id === value.Id}

                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="Select Executive" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.Id}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />
                                    </FormControl>
                                    <Tooltip title="Filter">
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={onFilterClick}
                                            sx={{ minWidth: '40px' }}
                                        >
                                            <Icon icon="ic:outline-filter-alt" width="20" height="20" sx={{ mr: '5px' }} />
                                        </Button>
                                    </Tooltip>

                                    {/* Reset */}
                                    <Tooltip title="Reset">
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={handleReset}
                                            sx={{ minWidth: '40px' }}

                                        >
                                            <Icon icon="ic:twotone-restart-alt" width="20" height="20" />
                                        </Button>
                                    </Tooltip>

                                </Stack>
                                <Box
                                    sx={{
                                        flex: 1,
                                        overflowY: 'auto',
                                        px: 0,
                                        maxHeight: "62vh",
                                    }}
                                >
                                    {teamRows?.length > 0 ? (
                                        teamRows?.map((item, index) => (
                                            <Box key={item.issueId || index} sx={{ pt: 1 }}>
                                                <Card
                                                    sx={{
                                                        p: 1,
                                                        border: "1px solid #E5E7EB",
                                                        borderRadius: "14px",
                                                        boxShadow: "none",
                                                    }}
                                                >
                                                    {/* HEADER */}
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                        borderBottom="1px solid #E5E7EB"
                                                        pb={1}

                                                    >
                                                        <Box display="flex" alignItems="center" gap={1}>
                                                            <Typography fontWeight={600} fontSize="16px">
                                                                {item.TeamName} Team
                                                            </Typography>

                                                            {/* Active Status */}
                                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                                <Box
                                                                    sx={{
                                                                        width: 8,
                                                                        height: 8,
                                                                        borderRadius: "50%",
                                                                        background: "#22C55E",
                                                                    }}
                                                                />
                                                                <Typography fontSize="13px" color="#22C55E">
                                                                    Active
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                        {/* DATE */}
                                                        <Typography fontSize="13px" color="#6B7280">
                                                            {item.FromDate} - {item.ToDate || "Present"}
                                                        </Typography>
                                                    </Box>

                                                    {/* DETAILS */}
                                                    <Grid container spacing={1}>
                                                        {/* Client ID */}
                                                        <Grid item xs={6}>
                                                            <Box sx={{ px: 2, py: 1 }}>
                                                                <Typography fontSize="11px" color="#9CA3AF">
                                                                    Client ID
                                                                </Typography>
                                                                <Typography fontSize="13px" fontWeight={500}>
                                                                    {item.ClientId}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>

                                                        {/* Client Name */}
                                                        <Grid item xs={6}>
                                                            <Box sx={{ px: 2, py: 1 }}>
                                                                <Typography fontSize="11px" color="#9CA3AF">
                                                                    Client Name
                                                                </Typography>
                                                                <Typography fontSize="13px" fontWeight={500}>
                                                                    {item.ClientName}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>

                                                        {/* Client Alice */}
                                                        <Grid item xs={6}>
                                                            <Box sx={{ px: 2, py: 1 }}>
                                                                <Typography fontSize="11px" color="#9CA3AF">
                                                                    Client Alice
                                                                </Typography>
                                                                <Typography fontSize="13px" fontWeight={500}>
                                                                    {item.ClientAlice}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>

                                                        {/* Project */}
                                                        <Grid item xs={6}>
                                                            <Box sx={{ px: 2, py: 1 }}>
                                                                <Typography fontSize="11px" color="#9CA3AF">
                                                                    Project
                                                                </Typography>
                                                                <Typography fontSize="13px" fontWeight={500}>
                                                                    {item.Project}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>

                                                    {/* FOOTER */}
                                                    <Box
                                                        pt={1}
                                                        borderTop="1px solid #E5E7EB"
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                    >
                                                        <Typography fontSize="13px">
                                                            {item.TeamMembers || 3} Team Members
                                                        </Typography>

                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                background: "#E11D48",
                                                                borderRadius: "10px",
                                                                textTransform: "none",
                                                                fontWeight: 600,
                                                                px: 2.5,
                                                                width: '140px',
                                                                height: '34px',
                                                                "&:hover": {
                                                                    backgroundColor: "#E11D48",
                                                                    color: "#FFFFFF",
                                                                },
                                                            }}
                                                        >
                                                            Make Inactive
                                                        </Button>
                                                    </Box>
                                                </Card>
                                            </Box>
                                        ))
                                    ) : (
                                        <Box
                                            sx={{
                                                height: '68vh',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexDirection: 'column',
                                                textAlign: 'center',
                                            }}
                                        >
                                            <Typography sx={{ color: '#E7000B', fontSize: 16, fontWeight: '500' }}>
                                                No Data Found
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    )}

                </Card>

            </Box >

            <Box sx={{ flex: 4.8, position: 'relative', display: 'flex', height: '472px', }}>
                <Card sx={{
                    borderRadius: '12px', width: "100%", border: '1px solid #E5E5E5', boxShadow: 'none', display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Box
                        sx={{
                            py: 1,
                            px: 2,
                            borderBottom: "1px solid #E5E5E5",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Box>
                            <Typography variant="subtitle1" fontWeight={600}>
                                Team Members
                            </Typography>
                            <Typography sx={{ color: "#94A3B8", fontSize: "12px" }}>
                                Search or create new team
                            </Typography>
                        </Box>

                        <Stack direction="row" spacing={1}>
                            <TextField
                                size="small"
                                placeholder="Search By Executive"
                                sx={{ width: 220 }}
                            />
                            <Button variant="contained" startIcon={<Icon icon="mdi:plus" />}>
                                Add New
                            </Button>
                        </Stack>
                    </Box>
                    {/* Scrollable Service Cards Section */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            p: 1,
                        }}
                    >
                        {[1, 2, 3, 4, 5].map((item) => (
                            <Card
                                key={item}
                                sx={{
                                    mb: 1,
                                    p: 2,
                                    borderRadius: "15px",
                                    border: "1px solid #E5E5E5",
                                    boxShadow: "none",
                                }}
                            >
                                <Stack direction="row" justifyContent="space-between">
                                    <Box>
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Typography fontWeight={500} fontSize={14}>
                                                Rakesh Shetty{" "}
                                                <Box component="span" sx={{ color: "#717182", fontWeight: 400 }}>
                                                    (SAPL-400) (322)
                                                </Box>
                                            </Typography>

                                            <Chip label="Development" size="small" sx={{ border: '1px solid #E5E5E5 ', borderRadius: '6px', fontSize: '10px', fontWeight: 500 }} />

                                            {item === 1 && (
                                                <Chip
                                                    label="Coordinator"
                                                    size="small"
                                                    sx={{ bgcolor: "#121212", color: "#fff", borderRadius: '6px', fontSize: '10px', fontWeight: 500 }}
                                                />
                                            )}
                                        </Stack>

                                        <Typography sx={{ color: "#717182", mt: 0.5 }}>
                                            DIVYRAJ, COEL AND MELT LLP • C0001 • 123456 • WinSpirit (6.0.32)
                                        </Typography>
                                        <Typography sx={{ mt: 0.5, fontSize: 13 }}>
                                            <Box component="span" sx={{ color: "#717182" }}>
                                                Period:
                                            </Box>{" "}
                                            <Box component="span" sx={{ color: "#3D3838" }}>
                                                31-jan-2025 → Present
                                            </Box>{" "}
                                            <Box component="span" sx={{ color: "#717182" }}>
                                                (392 days)
                                            </Box>
                                        </Typography>
                                    </Box>

                                    <Stack direction="row" spacing={1}>
                                        <Icon icon="material-symbols:person-check-outline-rounded" color="#0062FF" width={20} />
                                        <Icon icon="material-symbols:person-off-outline-rounded" color="#374151" width={20} />
                                    </Stack>
                                </Stack>
                            </Card>
                        ))}
                    </Box>
                </Card>
            </Box>
        </Box>

    )
}

